import Page from "webPage/Page";
import $ from "jquery";
import {loadMultipleGoogleMap} from "util/map-multiple";

Page.register('page-template-contact-us', () => {
    if ($('.js-google-map').length > 0) {
        loadMultipleGoogleMap($('.js-google-map'));
    }
});